"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentDetailsDoneState = exports.PaymentDetailsScreen = void 0;
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var pages_common_1 = require("@qwilr/pages-common");
var inversify_react_1 = require("inversify-react");
var react_1 = __importStar(require("react"));
var AcceptFlowContextProvider_1 = require("../AcceptFlowContextProvider");
var styles = __importStar(require("./PaymentDetailsScreen.css"));
var StripeContext_1 = require("./StripeContext");
var Utils_1 = require("./Utils");
var AddProjectTotals_1 = __importDefault(require("../AddProjectTotals"));
var AddQuoteDetails_1 = __importDefault(require("../Utils/AddQuoteDetails"));
var MaybeWrap_1 = __importDefault(require("@CommonFrontend/Utils/MaybeWrap"));
var PaymentForm_1 = require("./FormComponents/PaymentForm");
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var PaymentDetailsScreen = function (_a) {
    var _b;
    var onBack = _a.onBack, onCloseForm = _a.onCloseForm, onSubmit = _a.onSubmit;
    var _c = __read((0, react_1.useState)(false), 2), isSubmitting = _c[0], setIsSubmitting = _c[1];
    var _d = (0, AcceptFlowContextProvider_1.useAcceptFlowContext)(), payments = _d.payments, isPreviewAccept = _d.isPreviewAccept, disableFormSubmitReason = _d.disableFormSubmitReason;
    var stripeContext = (0, StripeContext_1.useStripeEnabledContext)();
    var projectCurrencies = (0, inversify_react_1.useInjection)("projectCurrencies");
    var projectTotal = (0, inversify_react_1.useInjection)("projectTotal");
    var quoteBlocksList = (0, inversify_react_1.useInjection)("quoteBlocksList");
    var usingFeature = (0, inversify_react_1.useInjection)("usingFeature");
    var visitToken = (0, inversify_react_1.useOptionalInjection)("visitToken");
    var _e = __read((0, pages_common_1.usePubSubEvent)("qwilr:quote-total-changed", {
        total: projectTotal.calculatePayTodaySingleCurrency(),
    }), 1), quoteTotal = _e[0].total;
    var disableFormSubmit = !!disableFormSubmitReason;
    var _f = (0, Utils_1.getPaymentDetails)(payments === null || payments === void 0 ? void 0 : payments.paymentSettings, projectCurrencies, quoteTotal), oneOffChargeAmount = _f.paymentAmount, currencyCode = _f.currencyCode, isPartialPayment = _f.isPartialPayment, partialPaymentPercentage = _f.partialPaymentPercentage;
    var billingSummary = projectTotal.getBillingSummary(currencyCode);
    var billingTotals = (0, Utils_1.getBillingTotals)(billingSummary);
    var hasRecurringPayment = usingFeature(FeatureFlag_1.default.QwilrPayRecurring) &&
        ((_b = payments === null || payments === void 0 ? void 0 : payments.paymentSettings.recurringConfig) === null || _b === void 0 ? void 0 : _b.enabled) &&
        billingTotals.recurring > 0;
    var paymentAmount = !isPartialPayment && hasRecurringPayment ? billingTotals["one-off"] + billingTotals.recurring : oneOffChargeAmount;
    return (react_1.default.createElement(kaleidoscope_1.Stack, { gap: "l" },
        react_1.default.createElement(kaleidoscope_1.Stack, { justify: "center", className: styles.headerStack, direction: "horizontal", align: "center" },
            react_1.default.createElement(kaleidoscope_1.IconButton, { isIconOnly: true, icon: react_1.default.createElement(icons_1.ArrowLeft, null), onClick: function () {
                    onBack();
                }, disabled: isSubmitting, className: styles.backButton }),
            react_1.default.createElement("div", { className: styles.iconContainer },
                react_1.default.createElement(icons_1.Subscription, { size: icons_1.IconSize.Large, className: styles.icon })),
            react_1.default.createElement(kaleidoscope_1.IconButton, { isIconOnly: true, icon: react_1.default.createElement(icons_1.Close, null), onClick: function () {
                    onCloseForm();
                }, disabled: isSubmitting, className: styles.closeButton })),
        react_1.default.createElement(kaleidoscope_1.FormComponent, { fieldSize: "large", className: styles.form, onSubmit: function (values) { return __awaiter(void 0, void 0, void 0, function () {
                var acceptanceData, name, email, addPayment, validatePaymentDetails, error_1;
                var _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            setIsSubmitting(true);
                            if (isPreviewAccept) {
                                setTimeout(function () {
                                    setIsSubmitting(false);
                                    onSubmit();
                                }, 500);
                                return [2];
                            }
                            if (!stripeContext.enabled) {
                                throw new Error("Missing setup for payments.");
                            }
                            acceptanceData = {};
                            (0, AddProjectTotals_1.default)(acceptanceData, projectTotal);
                            acceptanceData.sessionStartedAt = window.sessionStartTime;
                            (0, AddQuoteDetails_1.default)(quoteBlocksList, acceptanceData);
                            if (visitToken) {
                                acceptanceData.visitToken = visitToken;
                            }
                            name = (_a = values["name"]) === null || _a === void 0 ? void 0 : _a.toString();
                            email = (_b = values["email"]) === null || _b === void 0 ? void 0 : _b.toString();
                            if (!name || !email) {
                                throw new Error("Name and email are required to confirm payment.");
                            }
                            addPayment = stripeContext.addPayment, validatePaymentDetails = stripeContext.validatePaymentDetails;
                            _c.label = 1;
                        case 1:
                            _c.trys.push([1, 4, , 5]);
                            acceptanceData.payment = {
                                amount: paymentAmount,
                                currency: currencyCode,
                                name: name,
                                email: email,
                            };
                            return [4, validatePaymentDetails()];
                        case 2:
                            _c.sent();
                            return [4, addPayment(acceptanceData, {
                                    name: name,
                                    email: email,
                                })];
                        case 3:
                            _c.sent();
                            pages_common_1.PubSub.publish("qwilr:accept-flow-payment-added", {
                                paymentAdded: true,
                                paymentAddedAt: new Date().toString(),
                            });
                            setIsSubmitting(false);
                            onSubmit();
                            return [3, 5];
                        case 4:
                            error_1 = _c.sent();
                            setIsSubmitting(false);
                            if (error_1 instanceof Error) {
                                if (error_1.message === "stripe validation error") {
                                    return [2];
                                }
                                if (error_1.message === "duplicate payment") {
                                    return [2, (0, kaleidoscope_1.createFormSubmitErrorObject)("A payment has already been submitted by another accepter. Please refresh the page.")];
                                }
                                if (error_1.message === "Could not create a payment") {
                                    if (quoteTotal === undefined) {
                                        return [2, (0, kaleidoscope_1.createFormSubmitErrorObject)("Cannot submit a payment without a quote.")];
                                    }
                                    if (quoteTotal < 1) {
                                        return [2, (0, kaleidoscope_1.createFormSubmitErrorObject)("Cannot process a payment for the current amount.")];
                                    }
                                }
                                return [2, (0, kaleidoscope_1.createFormSubmitErrorObject)(error_1.message)];
                            }
                            console.error(error_1);
                            return [2, (0, kaleidoscope_1.createFormSubmitErrorObject)("An error occurred while submitting payment details; please try again later.")];
                        case 5: return [2];
                    }
                });
            }); } },
            react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(PaymentForm_1.PaymentForm, { shouldCollectBillingDetails: true, paymentConfiguration: {
                        isPartialPayment: isPartialPayment,
                        paymentAmount: paymentAmount,
                        currencyCode: currencyCode,
                        partialPaymentPercentage: partialPaymentPercentage,
                    } }),
                react_1.default.createElement(kaleidoscope_1.FormContext.Consumer, null, function (context) {
                    if (!context) {
                        throw new Error("FormContext must be inside a FormComponent");
                    }
                    var submitError = context.submitError;
                    return (react_1.default.createElement("div", null,
                        react_1.default.createElement(kaleidoscope_1.Expandable, { expanded: !!submitError, timeout: kaleidoscope_1.AnimationDuration.Short, "aria-live": "polite" }, function (_a) {
                            var expandableElementRef = _a.expandableElementRef;
                            return (react_1.default.createElement("div", { ref: expandableElementRef },
                                react_1.default.createElement(kaleidoscope_1.Alert, { heading: "Error", alertType: kaleidoscope_1.AlertType.Error }, submitError)));
                        })));
                }),
                react_1.default.createElement(MaybeWrap_1.default, { wrapper: function (children) {
                        if (disableFormSubmit && disableFormSubmitReason) {
                            return (react_1.default.createElement(kaleidoscope_1.Tooltip, { content: (0, Utils_1.getAcceptFormDisabledMessage)(disableFormSubmitReason), size: kaleidoscope_1.TooltipSize.Large, autoStack: false },
                                react_1.default.createElement("div", null, children)));
                        }
                    } },
                    react_1.default.createElement(kaleidoscope_1.FormSubmitButton, { width: "full", className: styles.formSubmitButton, disabled: disableFormSubmit }, "Add payment details"))))));
};
exports.PaymentDetailsScreen = PaymentDetailsScreen;
var PaymentDetailsDoneState = function (_a) {
    var onClose = _a.onClose;
    return (react_1.default.createElement(kaleidoscope_1.Stack, { gap: "l", justify: "center" },
        react_1.default.createElement(kaleidoscope_1.Stack, { justify: "center", className: styles.headerStack },
            react_1.default.createElement("div", { className: styles.iconContainer },
                react_1.default.createElement(icons_1.Subscription, { size: icons_1.IconSize.Large, className: styles.icon })),
            react_1.default.createElement(kaleidoscope_1.IconButton, { isIconOnly: true, icon: react_1.default.createElement(icons_1.Close, null), onClick: function () {
                    onClose();
                }, className: styles.closeButton })),
        react_1.default.createElement(kaleidoscope_1.Stack, { gap: "xl", align: "center" },
            react_1.default.createElement(kaleidoscope_1.Heading, { level: "3", align: "center" }, "Payment details added"),
            react_1.default.createElement(kaleidoscope_1.Button, { onClick: onClose }, "Done"))));
};
exports.PaymentDetailsDoneState = PaymentDetailsDoneState;
